export default "__VITE_PUBLIC_ASSET__9d535b45__"